/* @flow */
/* eslint-env es6,browser */

import globalParams from '../globalparams';
import adconfig from '../adconfig';
import { isCCPAOptedOut } from './ccpautils';
import { isFunction, isObject } from './coreutils';

/**
 * Returns filtered Custom Vars if CCPA Oupted-Out
 *
 * @param {window} w - window object
 *
 * @returns {object} - Custom Vars
 */
export default function getCVars(w: WindowProxy = null, bSkipOptout: boolean = false): anyObject {
  const gParams = globalParams.get();
  let cVars: CustomVars = gParams.customVars || {};
  const { settings } = adconfig.get();
  const { cvFilter } = settings;

  if (isFunction(cVars)) {
    // Let's pass page name to this function to get custom var
    cVars = cVars.call(w, adconfig.getPageName());
  }

  if (!isObject(cVars)) {
    // data sanitization
    cVars = {};
  }

  const lCVars = {};

  const doFilter = (!bSkipOptout && isCCPAOptedOut()) && cvFilter && cvFilter.length > 0;

  /* Create a copy of custom vars to avoid modifying/returning reference */
  Object.entries(cVars).forEach(([k, v]) => {
    /* Filter only if ccpa is opted out and cvFilter has atleast one value */
    if (!doFilter || !cvFilter.includes(k)) {
      lCVars[k] = v;
    }
  });

  return lCVars;
}
